import React, { useState, useCallback } from "react"
import CrewMembersPage from "./crewMembers/CrewMembersPage"
import EquipmentPage from "./equipment"
import DSTab from "ui/DSTab"
import { useTranslation } from "react-i18next"
import tabStyles from "./index.module.css"

const ResourcesContainer = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("equipment")

  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab)
  }, [])

  const tabItems = [
    {
      key: "equipment",
      label: t("resources.equipment")
    },
    {
      key: "crew",
      label: t("resources.crew")
    }
  ]

  return (
    <>
      <DSTab
        items={tabItems}
        activeKey={activeTab}
        onChange={handleTabChange}
        className={tabStyles.tabs}
      />
      {activeTab === "crew" && <CrewMembersPage />}
      {activeTab === "equipment" && <EquipmentPage />}
    </>
  )
}

export default React.memo(ResourcesContainer)
